<div class="info-container scrollable" *ngIf=" meta$ | async as _meta">
    <div class="centered">
        <section>
            <div class="info">
                <div class="generic group">
                        <div class="header">Algemeen</div>
                        <input-field title="Projectnummer" [readonly]="true" [value]="_meta.projectId"></input-field>
                        <input-field title="Omschrijving" [(value)]="_meta.description" (valueChange)="handleChangeMeta()"></input-field>
                        <input-field title="Opdrachtgever" [(value)]="_meta.client" (valueChange)="handleChangeMeta()"></input-field>
                        <div class="in-line">
                            <input-field title="Datum" [value]="$localDisplayDate | async | date:'dd-MM-yyyy':'UTC+0'" (focusLoss)="onDateFieldFocusOut()" (valueChange)="onDateValueChange($event)"></input-field>
                            <input-field title="Versie" [value]="_meta.displayVersion | default: _meta.currentVersion" (valueChange)="_meta.displayVersion = $event" (valueChange)="handleChangeMeta()"></input-field>
                        </div>
                        <checkbox-field title="Algemene voorwaarden" [(value)]="_meta.includeTerms" (valueChange)="handleChangeMeta()"></checkbox-field>
                        <checkbox-field *ngIf="_canHaveNetProvisionalPosts | async" title="Sta netto stelposten (na staart) toe" [(value)]="_meta.includeProvisionalPostLinesAfterTail" (valueChange)="handleChangeNetPosts()"></checkbox-field>
                    </div>
                    <div class="address group">
                        <div class="header">Adres</div>
                        <input-field title="Straat" [(value)]="_meta.address.address" (valueChange)="handleChangeMeta()"></input-field>
                        <div class="postal">
                            <input-field title="Postcode" [(value)]="_meta.address.postalCode" (valueChange)="handleChangeMeta()"></input-field>
                            <input-field title="Stad" [(value)]="_meta.address.city" (valueChange)="handleChangeMeta()"></input-field>
                        </div>
                        <input-field title="Land" [(value)]="_meta.address.country" (valueChange)="handleChangeMeta()"></input-field>
                    </div>
            </div>
        </section>
        <section>
            <div class="wages">
                <div class="header">Uurlonen</div>
                <div class="table">
                    <div class="row header">
                        <div class="col desc">Omschrijving</div>
                        <div class="col amount">Bedrag</div>
                    </div>
                    <div class="scrollable hide-scrollbar">
                        <div class="row" [class.selected]="selectedRow === i" (dblclick)="editHourlyRate(wage)" (click)="onSelectRow(i)" *ngFor="let wage of hourlyRates$ | async; let i = index">
                            <div class="col desc">{{ wage.description }}</div>
                            <div class="col amount">{{ wage.value | currency:'EUR':'' }}</div>
                            <div class="color" [style.background]="90 | gradient: wage.color: '0%': '#00000000': '2.5%'"></div>
                            <!-- <currency-input class="col amount" [value]="wage.wage" (valueChange)="onUpdateWage(wage, $event)"></currency-input> -->
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <div class="add btn" (click)="deleteSelected()" [class.inactive]="!canDelete">Verwijderen</div>
                    <div class="add btn" (click)="addHourlyWage()">Nieuw</div>
                </div>
            </div>
            <div class="percentages">
                <div class="header">Opslagen</div>
                <div class="table">
                    <div class="row header">
                        <div class="col cat">Categorie</div>
                        <div class="col percent">%</div>
                    </div>
                    <div class="scrollable hide-scrollbar">
                        <div class="row">
                            <div class="col cat">Uren</div>
                            <percent-input class="col percent" [(value)]="_meta.percentages.hours" (valueChange)="handleDefaultPercentagesChange()" (valueChange)="handleChangeMeta()"></percent-input>
                        </div>
                        <div class="row">
                            <div class="col cat">Materiaal</div>
                            <percent-input class="col percent" [(value)]="_meta.percentages.material" (valueChange)="handleDefaultPercentagesChange()" (valueChange)="handleChangeMeta()"></percent-input>
                        </div>
                        <div class="row">
                            <div class="col cat">Materieel</div>
                            <percent-input class="col percent" [(value)]="_meta.percentages.equipment" (valueChange)="handleDefaultPercentagesChange()" (valueChange)="handleChangeMeta()"></percent-input>
                        </div>
                        <div class="row">
                            <div class="col cat">Onderaaneming</div>
                            <percent-input class="col percent" [(value)]="_meta.percentages.subcontracting" (valueChange)="handleDefaultPercentagesChange()" (valueChange)="handleChangeMeta()"></percent-input>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>